import React from "react";
import {defineBlock, smartProps, useEditor, useSmartProp, useInspectorControl, useToolbar, ColorToolbarButton, ChildrenBlock, EditableDiv} from "@smartfire/wordpress-react";
import { PanelBody, PanelRow, TextControl, ToggleControl } from '@wordpress/components';
import { InnerBlocks } from '@wordpress/block-editor';
import style from "./block.module.scss";
import colorsconfig from "../shared/colorPalette";
import classnames from 'classnames'

function Toolbar() {
    const [backgroundColor, setBackgroundColor] = useSmartProp("backgroundColor");
    const colors = colorsconfig;
    return <>
            {colors && backgroundColor && <ColorToolbarButton colors={colors} color={backgroundColor} setColor={(c) => c ? setBackgroundColor(c) : null} />}
        </>
}

function Inspector(){
    useToolbar(Toolbar);
    const [anchorName, setAnchorName] = useSmartProp("anchorName");
    const [mirorMobile, setMirorMobile] = useSmartProp('mirorMobile');
    const [marginMobile, setMarginMobile] = useSmartProp('marginMobile');

    return <>
        <PanelBody title="Configuration ancre" initialOpen={true}>
            <PanelRow>
                <TextControl
                    label={("Nom de l'ancre")}
                    value={anchorName}
                    onChange={(value) => setAnchorName(value)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Inverser les colonnes en mobile" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={mirorMobile ? 'Oui' : 'Non'}
                    checked={mirorMobile}
                    onChange={() =>setMirorMobile(!mirorMobile)}
                />
            </PanelRow>
        </PanelBody>
        <PanelBody title="Marge entre les colonnes en mobile" initialOpen={true}>
            <PanelRow>
                <ToggleControl
                    label={marginMobile ? 'Oui' : 'Non'}
                    checked={marginMobile}
                    onChange={() =>setMarginMobile(!marginMobile)}
                />
            </PanelRow>
        </PanelBody>
    </>;
}

function Block({anchorName, backgroundColor, mirorMobile, marginMobile}) {
    const {isEditing} = useEditor();
    useInspectorControl(Inspector);

    const contentClasses = classnames({
        [style.content]: true,
        [style.reverse]: mirorMobile,
        [style.margin]: marginMobile
    });

    return <div className={style.block} style={{backgroundColor: backgroundColor}}>
                <div className={style.container}>
                    <div className={style.anchor} id={anchorName} />
                    <div className={contentClasses}>
                        <EditableDiv smartProps="title" tagName="h3" />
                        <div className={`${style[isEditing ? "childContentEdit" : "childContent"]}`}>
                            { isEditing ? 
                                <InnerBlocks
                                    template={[["smartfire/two-colonnes-item", {}],
                                    ["smartfire/two-colonnes-item", {}]
                                    ]}
                                    templateLock="all"
                                />:
                                <ChildrenBlock/>
                            }
                        </div>
                    </div>
                </div>
            </div>

}

export default defineBlock({ 
    Block, 
    smartProps: {
        anchorName: smartProps.string.withDefault(""),
        backgroundColor: smartProps.string.withDefault(style.blueBack),
        title: smartProps.string.withDefault(''),
        mirorMobile: smartProps.bool.withDefault(false),
        marginMobile: smartProps.bool.withDefault(true)
    },
    setup: {
        title: "2 Colonnes",
    },
});
